import { memo } from 'react';
import { BodyText, Row, SmallHeightDivider, StyledButtonOutlined } from '../../../../../../theme/Styles';
import { replaceGuionToSlashFromString } from '../../../../../../utilities/functions/StringUtil';
import {
    Container,
    RowContainer,
    ActionRequiredTitle,
    StyledWarningIcon,
    IconContainer,
    Title,
    ButtonContainer,
    ProgressBarContainer,
    ProgressBarPercent,
    ProgressBarTitle,
    ButtonsContainer,
    StatusText
} from './styles/SubServiceCardStyles';

function SubServiceCard({ title, approvalNumber, requestCode, status, onClick, onRequestClick, solutionColor, message, actionRequired, requestEnable, requested = false, date = new Date(), percent = '0' }) {

    return (
        <Container >
            <SmallHeightDivider />
            <SmallHeightDivider />

            {
                actionRequired != undefined &&
                <RowContainer>
                    <IconContainer>
                        <StyledWarningIcon />
                    </IconContainer>

                    <ActionRequiredTitle >
                        Esta solicitud requiere de tu acción para continuar.
                    </ActionRequiredTitle>
                </RowContainer>
            }

            <RowContainer style={{ justifyContent: 'space-between' }}>
                <Title>{title}</Title>
                <ButtonsContainer>
                    <ButtonContainer>
                        {requested !== true &&

                            <StyledButtonOutlined disabled={!requestEnable} onClick={onRequestClick} variant="outlined">
                                Iniciar Solicitud
                            </StyledButtonOutlined>
                        }
                    </ButtonContainer>

                    <ButtonContainer>
                        <StyledButtonOutlined onClick={onClick} variant="outlined">
                            {actionRequired != undefined ? 'COMPLETAR' : 'ver información'}
                        </StyledButtonOutlined>
                    </ButtonContainer>
                </ButtonsContainer>
            </RowContainer>

            <RowContainer style={{ justifyContent: 'flex-start' }}>
                <BodyText>
                    Fecha: {new Date(replaceGuionToSlashFromString(date)).toLocaleDateString()}
                </BodyText>
            </RowContainer>
            {requestCode != undefined &&
                <RowContainer style={{ justifyContent: 'flex-start' }}>
                    <BodyText>
                        Solicitud No.: {requestCode}
                    </BodyText>
                </RowContainer>
            }
            {approvalNumber != undefined ?
                <RowContainer style={{ justifyContent: 'flex-start' }}>
                    <BodyText>
                        Numero de aprobación: {approvalNumber}
                    </BodyText>
                </RowContainer>
                :
                <RowContainer style={{ justifyContent: 'flex-start' }}>

                    {/* PENDIENTE CORREGIR MONTO */}
                    {/* <BodyText>
                        Monto: {paymentData.payment_amount === '0.00' ?
                            "Gratis" : `DOP${paymentData.payment_amount}`}
                    </BodyText> */}
                </RowContainer>
            }

            <RowContainer style={{ justifyContent: 'flex-start' }}>

                <Row>
                    <BodyText>
                        Estado :
                    </BodyText>
                    <StatusText status={solutionColor}>
                        <strong>
                            {status}
                        </strong>
                    </StatusText>
                </Row>

            </RowContainer>

            <SmallHeightDivider />

            <RowContainer>
                <ProgressBarContainer>
                    <ProgressBarTitle style={{position: "static"}} variant={'inProcess'}>
                        {
                            percent + ' COMPLETADO'
                        }
                    </ProgressBarTitle>
                    <ProgressBarPercent variant={'inProcess'} percent={percent} />
                </ProgressBarContainer>
            </RowContainer>
            <SmallHeightDivider />
        </Container>
    );
}

export default memo(SubServiceCard);
